import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { List, ListItem } from "material-ui/List";
import IconButton from "material-ui/IconButton";
import IconDelete from "material-ui/svg-icons/action/delete-forever";
import NormalTextField from "../../components/common/NormalTextField";

import IconClose from "material-ui/svg-icons/navigation/close";
import {
  Button,
  FormControl,
  FormControlLabel,
  InputLabel,
  Select,
  TextField,
} from "@material-ui/core";
import Switch from "@material-ui/core/Switch";
import StarIcon from "@material-ui/icons/Star";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import colors from "../../styles/colors";
import NormalFlatButton from "../../components/common/NormalFlatButton";

class CategorySelector extends Component {
  constructor(props) {
    super(props);

    let dropDownOptions = [
      { value: "all", label: "Show All Instructions" },
      { value: "fav", label: "Show My Favorites" },
    ];
    if (props.programs) {
      props.programs
        .filter((p) => {
          return !p.systemUse;
        })
        .map((p) => {
          dropDownOptions.push({
            value: p.programId,
            label: p.programName,
          });
          return true;
        });
    }

    this.state = {
      filterText: "",
      selectedFilter: "all",
      selectedProgram: null,
      dropDownOptions,
      programs: props.programs,
      newlySelected: [],
    };

    this.handleSelectionChange = this.handleSelectionChange.bind(this);
  }

  isInFavorites(id) {
    if (
      this.props &&
      this.props.appFavorite &&
      this.props.appFavorite.instructions
    ) {
      return this.props.appFavorite.instructions.includes(id);
    } else {
      return false;
    }
  }

  handleSwitchChange(checked, instruction) {
    let instList = this.state.newlySelected;
    if (checked) {
      instList.push(instruction);
    } else {
      instList = instList.filter((i) => {
        return i.categoryId !== instruction.categoryId;
      });
    }
    this.setState({
      newlySelected: instList,
    });
  }

  clearSelection() {
    this.setState({
      newlySelected: [],
    });
  }

  handleSelectAll() {
    let instList = this.state.newlySelected;
    _.values(this.props.categories)
      .filter((c) => {
        if (this.state.selectedFilter === "all") {
          return true;
        } else if (this.state.selectedFilter === "fav") {
          return this.props.appFavorite.instructions.includes(c.categoryId);
        } else {
          return this.state.selectedProgram.instructions.includes(c.categoryId);
        }
      })
      .filter((category) => {
        if (this.state.filterText) {
          if (this.state.canSearchByGroup) {
            return category.groupName
              .toLowerCase()
              .startsWith(this.state.filterText.toLowerCase());
          } else {
            return category.categoryName
              .toLowerCase()
              .startsWith(this.state.filterText.toLowerCase());
          }
        } else {
          return true;
        }
      })
      .map((inst) => {
        let found = false;
        instList.map((i) => {
          if (i.categoryId === inst.categoryId) {
            found = true;
          }

          return true;
        });

        if (!found) {
          instList.push(inst);
        }
      });

    this.setState({
      newlySelected: instList,
    });
  }

  handleSelectionChange(e) {
    let selectedProgram = null;
    if (e.target.value !== "fav" && e.target.value !== "") {
      let arr = this.state.programs.filter((p) => {
        return p.programId === e.target.value;
      });
      selectedProgram = arr[0];
    }
    this.setState({ selectedFilter: e.target.value, selectedProgram });
  }

  saveAndClose() {
    const list = this.state.newlySelected.map((inst) => inst.categoryId);
    this.props.addFunction(list);
    this.props.close();
  }

  render() {
    let size = _.size(this.props.categories);
    return (
      <div>
        <div
          style={{
            backgroundColor: "#f0f0f0",
            marginBottom: 15,
            marginTop: 15,
            border: "solid 2px #CECECE",
            padding: 10,
            borderRadius: 7,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
              flex: 1,
              margin: 15,
            }}
          >
            <FormControl variant="outlined" style={{ width: "100%" }}>
              <InputLabel htmlFor="outlined-filter">Filter</InputLabel>
              <Select
                native
                value={this.state.selectedFilter}
                onChange={this.handleSelectionChange}
                label="Filter"
                inputProps={{
                  name: "filter",
                  id: "outlined-filter",
                }}
                style={{ width: "100%" }}
              >
                {this.state.dropDownOptions.map((o) => {
                  return <option value={o.value}>{o.label}</option>;
                })}
              </Select>
            </FormControl>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <TextField
              id="filled-full-width"
              label={
                this.state.canSearchByGroup
                  ? "Search By Category"
                  : "Search By Name"
              }
              type="search"
              style={{ margin: 8 }}
              placeholder={
                this.state.canSearchByGroup
                  ? "Search By Category"
                  : "Search By Name"
              }
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={this.state.filterText}
              onChange={(e) => {
                this.setState({ filterText: e.target.value });
              }}
            />
            <FormControlLabel
              control={
                <Switch
                  checked={this.state.showAll}
                  onChange={(val) => {
                    const curVal = this.state.canSearchByGroup;
                    this.setState({ canSearchByGroup: !curVal });
                  }}
                  name="toggleAll"
                  color={colors.accent}
                  style={{ color: colors.primary }}
                />
              }
              labelPlacement="start"
              label="Search By Category"
              style={{ width: 300, marginRight: 10, color: colors.primary }}
            />
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <FormControlLabel
            control={
              <Switch
                checked={this.state.didSelectAll}
                onChange={(val) => {
                  const curVal = this.state.didSelectAll;
                  this.setState({ didSelectAll: !curVal });
                  if (!curVal) {
                    this.handleSelectAll();
                  } else {
                    this.clearSelection();
                  }
                }}
                name="toggleAll"
                color={colors.accent}
                style={{ color: colors.accent }}
              />
            }
            style={{
              borderStyle: "solid",
              borderWidth: 1,
              borderColor: colors.primary,
              borderRadius: 7,
              paddingLeft: 15,
              marginRight: 10,
              color: colors.primary,
            }}
            labelPlacement="start"
            label={this.state.didSelectAll ? "Clear Selection" : "Select All"}
          />
        </div>
        <List>
          {size < 1 && <div>No more categories</div>}
          {size > 0 &&
            _.values(this.props.categories)
              .filter((c) => {
                if (this.state.selectedFilter === "all") {
                  return true;
                } else if (this.state.selectedFilter === "fav") {
                  return this.props.appFavorite.instructions.includes(
                    c.categoryId
                  );
                } else {
                  return this.state.selectedProgram.instructions.includes(
                    c.categoryId
                  );
                }
              })
              .filter((category) => {
                if (this.state.filterText) {
                  if (this.state.canSearchByGroup) {
                    return category.groupName
                      .toLowerCase()
                      .startsWith(this.state.filterText.toLowerCase());
                  } else {
                    return category.categoryName
                      .toLowerCase()
                      .includes(this.state.filterText.toLowerCase());
                  }
                } else {
                  return true;
                }
              })
              .map((inst) => {
                return (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      border: "solid 1px grey",
                      borderRadius: 7,
                      margin: 10,
                      padding: 5,
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "space-between",
                        margin: 0,
                        padding: 0,
                      }}
                    >
                      <div
                        style={{
                          margin: 0,
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                        }}
                      >
                        {this.isInFavorites(inst.categoryId) ? (
                          <StarIcon
                            fontSize="small"
                            style={{ color: "orange" }}
                          />
                        ) : (
                          <StarBorderIcon fontSize="small" />
                        )}
                        <span
                          style={{
                            fontSize: 16,
                            fontFamily: "Poppins-Semibold",
                            marginRight: 30,
                            marginLeft: 5,
                            color: "black",
                          }}
                        >
                          {inst.categoryName}
                        </span>
                        <span
                          style={{
                            margin: 0,
                            padding: 5,
                            backgroundColor: colors.primary,
                            color: colors.white,
                            borderRadius: 5,
                            fontSize: 12,
                            fontFamily: "Poppins-Regular",
                          }}
                        >
                          {inst.groupName}
                        </span>
                      </div>
                      <Switch
                        color={colors.accent}
                        style={{ color: colors.accent }}
                        checked={this.state.newlySelected.includes(inst)}
                        onChange={(event) => {
                          this.handleSwitchChange(event.target.checked, inst);
                        }}
                      />
                    </div>
                    <p
                      style={{
                        margin: 0,
                        fontSize: 12,
                        color: colors.grey,
                        textOverflow: "ellipsis",
                      }}
                    >
                      {inst.categoryDesc}
                    </p>
                  </div>
                );
              })}
        </List>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
          }}
        >
          <NormalFlatButton
            label="Cancel"
            onClick={() => this.props.close()}
            style={{ marginRight: 20 }}
          />
          <Button
            label="Save"
            onClick={() => this.saveAndClose()}
            variant="outlined"
            style={{ backgroundColor: "orange", color: "white" }}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

CategorySelector.propTypes = {
  categories: PropTypes.array.isRequired,
  onClick: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CategorySelector;



// WEBPACK FOOTER //
// ./src/layout/playbook/CategorySelector.js